// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Administration {
  background: #abc;
}

.Apostleship {
  background: #ced;
}

.Discernment {
  background: #fea;
}

.Encouragement {
  background: #daf;
}

.Evangelism {
  background: #aab;
}

.Faith {
  background: #eda;
}

.Giving {
  background: #afa;
}

.Service {
  background: rgb(162, 244, 181);
}

.Hospitality {
  background: rgb(190, 161, 127);
}

.Knowledge {
  background: rgb(182, 178, 254);
}

.Leadership {
  background: turquoise;
}

.Mercy {
  background: pink;
}

.Shepherding {
  background: #eea;
}

.Discipling {
  background: #bfe;
}

.Prophecy {
  background: rgb(186, 152, 155);
}

.Teaching {
  background: rgb(192, 198, 194);
}

.Wisdom {
  background: #8c2;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInF1ZXN0aW9ucy5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGdCQUFBO0FBQ0Y7O0FBQ0E7RUFDRSxnQkFBQTtBQUVGOztBQUFBO0VBQ0UsZ0JBQUE7QUFHRjs7QUFEQTtFQUNFLGdCQUFBO0FBSUY7O0FBRkE7RUFDRSxnQkFBQTtBQUtGOztBQUhBO0VBQ0UsZ0JBQUE7QUFNRjs7QUFKQTtFQUNFLGdCQUFBO0FBT0Y7O0FBTEE7RUFDRSw4QkFBQTtBQVFGOztBQU5BO0VBQ0UsOEJBQUE7QUFTRjs7QUFQQTtFQUNFLDhCQUFBO0FBVUY7O0FBUkE7RUFDRSxxQkFBQTtBQVdGOztBQVRBO0VBQ0UsZ0JBQUE7QUFZRjs7QUFWQTtFQUNFLGdCQUFBO0FBYUY7O0FBWEE7RUFDRSxnQkFBQTtBQWNGOztBQVpBO0VBQ0UsOEJBQUE7QUFlRjs7QUFiQTtFQUNFLDhCQUFBO0FBZ0JGOztBQWRBO0VBQ0UsZ0JBQUE7QUFpQkYiLCJmaWxlIjoicXVlc3Rpb25zLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLkFkbWluaXN0cmF0aW9uIHtcbiAgYmFja2dyb3VuZDogI2FiYztcbn1cbi5BcG9zdGxlc2hpcCB7XG4gIGJhY2tncm91bmQ6ICNjZWQ7XG59XG4uRGlzY2Vybm1lbnQge1xuICBiYWNrZ3JvdW5kOiAjZmVhO1xufVxuLkVuY291cmFnZW1lbnQge1xuICBiYWNrZ3JvdW5kOiAjZGFmO1xufVxuLkV2YW5nZWxpc20ge1xuICBiYWNrZ3JvdW5kOiAjYWFiO1xufVxuLkZhaXRoIHtcbiAgYmFja2dyb3VuZDogI2VkYTtcbn1cbi5HaXZpbmcge1xuICBiYWNrZ3JvdW5kOiAjYWZhO1xufVxuLlNlcnZpY2Uge1xuICBiYWNrZ3JvdW5kOiByZ2IoMTYyLCAyNDQsIDE4MSk7XG59XG4uSG9zcGl0YWxpdHkge1xuICBiYWNrZ3JvdW5kOiByZ2IoMTkwLCAxNjEsIDEyNyk7XG59XG4uS25vd2xlZGdlIHtcbiAgYmFja2dyb3VuZDogcmdiKDE4MiwgMTc4LCAyNTQpO1xufVxuLkxlYWRlcnNoaXAge1xuICBiYWNrZ3JvdW5kOiB0dXJxdW9pc2U7XG59XG4uTWVyY3kge1xuICBiYWNrZ3JvdW5kOiBwaW5rO1xufVxuLlNoZXBoZXJkaW5nIHtcbiAgYmFja2dyb3VuZDogI2VlYTtcbn1cbi5EaXNjaXBsaW5nIHtcbiAgYmFja2dyb3VuZDogI2JmZTtcbn1cbi5Qcm9waGVjeSB7XG4gIGJhY2tncm91bmQ6IHJnYigxODYsIDE1MiwgMTU1KTtcbn1cbi5UZWFjaGluZyB7XG4gIGJhY2tncm91bmQ6IHJnYigxOTIsIDE5OCwgMTk0KTtcbn1cbi5XaXNkb20ge1xuICBiYWNrZ3JvdW5kOiAjOGMyO1xufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/questions/questions.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AACA;EACE,gBAAA;AAEF;;AAAA;EACE,gBAAA;AAGF;;AADA;EACE,gBAAA;AAIF;;AAFA;EACE,gBAAA;AAKF;;AAHA;EACE,gBAAA;AAMF;;AAJA;EACE,gBAAA;AAOF;;AALA;EACE,8BAAA;AAQF;;AANA;EACE,8BAAA;AASF;;AAPA;EACE,8BAAA;AAUF;;AARA;EACE,qBAAA;AAWF;;AATA;EACE,gBAAA;AAYF;;AAVA;EACE,gBAAA;AAaF;;AAXA;EACE,gBAAA;AAcF;;AAZA;EACE,8BAAA;AAeF;;AAbA;EACE,8BAAA;AAgBF;;AAdA;EACE,gBAAA;AAiBF;AACA,4pDAA4pD","sourcesContent":[".Administration {\n  background: #abc;\n}\n.Apostleship {\n  background: #ced;\n}\n.Discernment {\n  background: #fea;\n}\n.Encouragement {\n  background: #daf;\n}\n.Evangelism {\n  background: #aab;\n}\n.Faith {\n  background: #eda;\n}\n.Giving {\n  background: #afa;\n}\n.Service {\n  background: rgb(162, 244, 181);\n}\n.Hospitality {\n  background: rgb(190, 161, 127);\n}\n.Knowledge {\n  background: rgb(182, 178, 254);\n}\n.Leadership {\n  background: turquoise;\n}\n.Mercy {\n  background: pink;\n}\n.Shepherding {\n  background: #eea;\n}\n.Discipling {\n  background: #bfe;\n}\n.Prophecy {\n  background: rgb(186, 152, 155);\n}\n.Teaching {\n  background: rgb(192, 198, 194);\n}\n.Wisdom {\n  background: #8c2;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
